export default __webpack_public_path__ + "static/media/prof-pic.5c5a4b7b.png";